module.exports = __webpack_public_path__ + "img/mb.3a288f37.png";